



import MyProfileMobile from '../sections/my_profile/template_01';




import "./style.css";

const ProfileMobile = ()=>{
return (
<div id="profileMobile" className="page">
  
  

  
  <MyProfileMobile mobileTitleToggle={ true } />
  
  
  
</div>
)
}

export default ProfileMobile;